interface MentionIconProps {
  fill?: string;
}
const MentionIcon = ({ fill }: MentionIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_1238_15338)">
        <path
          d="M10 5.83338C10.9381 5.83338 11.8036 6.14357 12.5 6.66671C12.5 6.20648 12.8731 5.83338 13.3333 5.83338C13.7936 5.83338 14.1667 6.20648 14.1667 6.66671V10.8334C14.1667 11.2754 14.3424 11.6992 14.655 12.0118C14.9675 12.3243 15.3913 12.5 15.8333 12.5C16.2754 12.5 16.6992 12.3243 17.0117 12.0118C17.3243 11.6992 17.5 11.2754 17.5 10.8334V10C17.5 8.31064 16.9297 6.67068 15.8814 5.34591C14.8329 4.02109 13.3672 3.08923 11.7228 2.70105C10.0786 2.31295 8.3515 2.49121 6.8213 3.20724C5.2912 3.92325 4.04741 5.1346 3.29184 6.64555C2.53626 8.15671 2.31338 9.87939 2.6587 11.5332C3.00407 13.187 3.89746 14.676 5.19451 15.7585C6.4916 16.841 8.11665 17.4537 9.80551 17.4976C11.4943 17.5414 13.1488 17.0138 14.5003 16.0002C14.8685 15.7242 15.3904 15.7989 15.6665 16.167C15.9425 16.5352 15.8678 17.0571 15.4997 17.3332C13.8477 18.5721 11.8258 19.2171 9.76156 19.1635C7.69748 19.1097 5.71208 18.3608 4.1268 17.0378C2.54141 15.7147 1.44908 13.8948 1.02703 11.8734C0.60504 9.8522 0.877622 7.74777 1.80095 5.90092C2.72441 4.054 4.24464 2.57283 6.11492 1.69764C7.98525 0.822455 10.0964 0.603905 12.1061 1.07833C14.1159 1.55276 15.9068 2.69234 17.1883 4.31157C18.4697 5.93074 19.1667 7.9352 19.1667 10V10.8334C19.1667 11.7174 18.8152 12.565 18.1901 13.1901C17.565 13.8153 16.7174 14.1667 15.8333 14.1667C14.9493 14.1667 14.1017 13.8153 13.4766 13.1901C13.3439 13.0575 13.2241 12.9146 13.1169 12.7637C12.3536 13.6239 11.2405 14.1667 10 14.1667C7.69882 14.1667 5.83334 12.3012 5.83334 10C5.83334 7.69886 7.69882 5.83338 10 5.83338ZM7.50001 10C7.50001 11.3808 8.6193 12.5 10 12.5C11.3807 12.5 12.5 11.3808 12.5 10C12.5 8.61933 11.3807 7.50004 10 7.50004C8.6193 7.50004 7.50001 8.61933 7.50001 10Z"
          fill={fill ?? "#313131"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1238_15338">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MentionIcon;
